import "./heroSlider.scss";
export class HeroSlider {

    private _options = {
        maxSlides: 5,
        delay: 5000,
        heroContainer: <HTMLElement>{},
        infinite: true
    };

    private _slides = [];

    private activeSlide = 0;

    private rotator;

    buildImages() {
        const heroContainer = this.hero;
        const slideContainer = document.createElement("div");
        slideContainer.classList.add("hero-slides");
        let isFirst = true;
        for (let i = 0; i < this.maxSlides; i++) {
            const slide = document.createElement("div");
            slide.id = 'slide-' + i;
            slide.style.backgroundImage = 'url("' + this.getSlides(i) + '")';
            slide.classList.add('hero-slide');
            if (isFirst) {
                slide.classList.add('active');
                isFirst = false;
            }
            slideContainer.appendChild(slide);
        }
        heroContainer.appendChild(slideContainer);
    }

    constructor(selector, props) {
        window.addEventListener('DOMContentLoaded', (event) => {
            const heroContainer = document.querySelector(selector);

            if (heroContainer) {
                this.hero = heroContainer;
                this._slides = props.slides;
                this.infinite = props.infinite;
                if (props.delay) this._options.delay = props.delay;
                this.maxSlides = this._slides.length;
                this.startHero();
            }
        });
    }

    get hero() {
        return this._options.heroContainer;
    }

    set hero(obj) {
        this._options.heroContainer = obj;
    }

    get delay() {
        return this._options.delay;
    }

    get infinite() {
        return this._options.infinite;
    }

    set infinite(status) {
        this._options.infinite = status;
    }

    getSlides(index) {
        return this._slides[index];
    }
    get maxSlides() {
        return this._options.maxSlides;
    }

    set maxSlides(count) {
        this._options.maxSlides = count;
    }

    get currentSlide() {
        return this.activeSlide;
    }

    set currentSlide(slide) {
        this.activeSlide = slide;
    }

    setSlideBackground() {
        const heroContainer = this.hero;
        const currentSlide = document.getElementById('slide-' + this.currentSlide);
        const nextSlideId = (this.currentSlide + 1 < this.maxSlides) ? this.currentSlide + 1 : 0;
        const nextSlide = document.getElementById('slide-' + nextSlideId);
        currentSlide.classList.remove('active');
        nextSlide.classList.add('active');
        // Set the current Slide
        this.currentSlide = nextSlideId;
    }

    rotateHero() {
        this.setSlideBackground();
    }

    startHero() {
        // Add images to page
        this.buildImages();

        // Start the rotation
        this.rotator = setInterval(() => {
            if (this.currentSlide + 1 === this.maxSlides && !this.infinite) clearInterval(this.rotator);
            else this.rotateHero();
        }, this.delay);
    }

}